import hover_white_icon from "../../../assets/icons/hover_white_arrow.svg";
import initial_white_icon from "../../../assets/icons/inital_white_arrow.svg";
import CustomLink from "../../primitive/CustomLink";

const ReuseablePartnershipSection = ({
  preTitle,
  title,
  description,
  cta,
  steps,
  colors,
}) => {
  return (
    <div
      style={{
        backgroundColor: colors?.backgroundColor || "white",
      }}
    >
      <div className="container mx-auto flex flex-col gap-16 xl:gap-[84px] items-center py-11 xl:py-[72px]">
        <div className="flex flex-col gap-3 xl:gap-4 items-center">
          <p
            className="rounded-2xl py-1 px-2 xl:py-2 xl:px-3 text-[#202D66] text-xs xl:text-sm"
            style={{
              backgroundColor: colors?.preTitleBackgroundColor || "white",
            }}
          >
            {preTitle}
          </p>

          <h4 className="font-test-sohne-medium text-lg xl:text-2xl">
            {title}
          </h4>

          <p className="text-lg xl:text-2xl xl:leading-[48px] text-center">
            {description}
          </p>

          <div className="xl:mt-4 mt-3">
            {cta?.link ? (
              <CustomLink
                to={cta?.link || "/"}
                title={cta?.text || "Get Started"}
                className="bg-Ebony text-sm xl:text-lg text-white hover:bg-ShipGrey"
                inital_arrow={initial_white_icon}
                hover_arrow={hover_white_icon}
                target={cta?.target}
              />
            ) : cta?.action && typeof cta?.action === "function" ? (
              <button
                className="group bg-Ebony relative pr-10 flex items-center justify-center gap-1 rounded-full px-4 py-2 text-sm xl:text-lg text-white hover:bg-ShipGrey"
                onClick={() => cta?.action?.()}
              >
                {cta?.text || "Get started"}
                <div className="flex items-center h-full absolute right-4">
                  <img
                    src={hover_white_icon}
                    className={`pt-0.5 transition-opacity  duration-300 ${"group-hover:opacity-100 opacity-0"}`}
                    alt=""
                  />
                  <img
                    src={initial_white_icon}
                    className={`pt-0.5 transition-opacity duration-300 ${"group-hover:opacity-0 opacity-100"}`}
                    alt=""
                  />
                </div>
              </button>
            ) : null}
          </div>
        </div>

        <div className="max-w-4xl grid grid-cols-1 xl:grid-cols-2 gap-y-10 gap-x-7 xl:gap-y-[86px] xl:gap-x-10">
          {steps?.map((step, index) => (
            <div
              key={index}
              className={`relative flex flex-col items-center gap-4 xl:gap-6 pb-7 xl:pb-12 border border-[#E2E8F0] rounded-3xl bg-white ${
                steps?.length === 3 && index === 2
                  ? "xl:justify-self-center xl:col-span-2 xl:max-w-[426px]"
                  : ""
              }`}
              style={{
                boxShadow: "0px 1px 2px 0px #0A0D120D",
              }}
            >
              <p
                className="absolute border-2 xl:border-4 border-[#F8FAFC] bg-[#002C72] rounded-full h-9 xl:h-[50px] w-9 xl:w-12 grid place-items-center text-white font-test-sohne-bold xl:text-2xl -top-2 xl:-top-2.5 -left-3 xl:-left-4"
                style={{
                  boxShadow: "0px 16px 24px 0px #00000026",
                }}
              >
                {index + 1}
              </p>

              <img
                src={step?.image}
                alt={title}
                className="w-full h-auto xl:h-[203px] rounded-t-3xl object-cover"
              />

              <div className="flex flex-col gap-0.5 xl:gap-3 px-4 xl:px-6 text-center">
                <h4 className="text-[#334155] font-test-sohne-semibold text-base xl:text-xl">
                  {step?.title}
                </h4>

                <p className="text-[#64748B] text-xs xl:text-sm">
                  {step?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReuseablePartnershipSection;
